import React, { useState } from 'react';
import Section from './Section';
import { X_PADDING } from '../constants';
import Page from './Page';
import { 
  FaLandmark,
  FaHeartbeat,
  FaShieldAlt,
  FaFileContract,
} from 'react-icons/fa';

const Advocacy = () => {
  return (
    <Page name="Advocacy on Health Insurance in Zambia">
      <div className="w-full pt-8 bg-white">
        {/* Advocacy in Health Care Section */}
        <Section
          name="Advocacy in Health Care"
          description="COAZ is committed to advocating for policies and legislation that strengthen the Clinical Officer profession and improve healthcare delivery across Zambia. Through strategic advocacy at multiple levels, we work to ensure that clinical officers have the support, resources, and legal framework needed to provide quality healthcare to all Zambians."
        />

        {/* State Advocacy Section */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="border border-[#eef1f4] rounded-lg p-8 bg-white shadow-sm">
            <div className="flex items-center gap-3 mb-5">
              <FaLandmark className="text-[#1477c2]" size={24} />
              <h2 className="text-2xl font-bold text-[#16365c]">
                State Advocacy
              </h2>
            </div>

            <p className="text-[#7c8a97] leading-8 mb-4">
              At the state level, the COAZ shapes the policy of influential national policymaking, partners with outside experts and stakeholder groups and influences the enactment and/or defeat of state legislation and regulation.
            </p>

            <h3 className="text-lg font-bold text-[#16365c] mb-4 mt-6">
              Our State Legislative and Regulatory Priorities
            </h3>

            <ul className="space-y-3">
              <PriorityPoint 
                icon={<FaFileContract className="text-[#1b9de3]" size={16} />}
                text="Legislative Amendment to the medicines and Allied substances act"
              />
              <PriorityPoint 
                icon={<FaFileContract className="text-[#1b9de3]" size={16} />}
                text="Legislative amendment to the Health Professions council of Zambia to reflect communities of practice, that considers of clinical practitioners' community of practice"
              />
              <PriorityPoint 
                icon={<FaFileContract className="text-[#1b9de3]" size={16} />}
                text="Legislative amendment to the food and nutrition act of 2020"
              />
              <PriorityPoint 
                icon={<FaFileContract className="text-[#1b9de3]" size={16} />}
                text="Legislative enactment of the National Health services act"
              />
              <PriorityPoint 
                icon={<FaFileContract className="text-[#1b9de3]" size={16} />}
                text="Legislative enactment of the Clinical Officers bill"
              />
              <PriorityPoint 
                icon={<FaFileContract className="text-[#1b9de3]" size={16} />}
                text="Legislative enactment of Affordable Care Act"
              />
              <PriorityPoint 
                icon={<FaFileContract className="text-[#1b9de3]" size={16} />}
                text="Opening regulatory documents for Clinical officer specialists with HPCZ"
              />
            </ul>
          </div>
        </div>

        {/* Access to Health Care Section */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="border border-[#eef1f4] rounded-lg p-8 bg-white shadow-sm">
            <div className="flex items-center gap-3 mb-5">
              <FaHeartbeat className="text-[#1477c2]" size={24} />
              <h2 className="text-2xl font-bold text-[#16365c]">
                Access to Health Care
              </h2>
            </div>

            <p className="text-[#7c8a97] leading-8 mb-4">
              The COAZ works tirelessly to preserve health care access and coverage for Zambians across the nation — especially the country's most vulnerable and underserved patient populations.
            </p>

            <h3 className="text-lg font-bold text-[#16365c] mb-4 mt-6">
              Our Current Focus on Access to Health Care Include:
            </h3>

            <ul className="space-y-3">
              <PriorityPoint 
                icon={<FaShieldAlt className="text-[#1b9de3]" size={16} />}
                text="National health insurance (NHIMA) coverage for all Zambians"
              />
              <PriorityPoint 
                icon={<FaShieldAlt className="text-[#1b9de3]" size={16} />}
                text="Freedom of choice"
              />
              <PriorityPoint 
                icon={<FaShieldAlt className="text-[#1b9de3]" size={16} />}
                text="Freedom of practice for clinical officers to increase universal access for patients"
              />
            </ul>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Advocacy;

// Priority Point Component
const PriorityPoint = ({ icon, text }) => {
  return (
    <li className="flex items-start gap-3 p-3 bg-white rounded-lg border border-[#eef1f4]">
      <span className="text-[#1b9de3] mt-0.5 flex-shrink-0">
        {icon}
      </span>
      <span className="text-[#16365c] text-sm leading-relaxed">
        {text}
      </span>
    </li>
  );
};

